import { Button, TextField } from "@mui/material";
import { ChangeEvent, useState, FocusEvent } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

interface Props {
  setToken: (token: string) => void;
  setKayttajaId: (kayttajaId: number) => void;
}

const Login: React.FC<Props> = (props: Props): React.ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  const [kirjautumistiedot, setKirjautumistiedot] = useState({
    name: "",
    password: "",
    confirmPassword: ""
  });
  const [needsPasswordUpdate, setNeedsPasswordUpdate] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setKirjautumistiedot({
      ...kirjautumistiedot,
      [name]: value
    });
  };

  const handlePasswordFocus = async (e: FocusEvent<HTMLInputElement>) => {
    const { name } = kirjautumistiedot;

    if (name) {
      const response = await fetch("/api/auth/check-password", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ kayttajatunnus: name })
      });

      const result = await response.json();

      if (result.needsPasswordUpdate) {
        setNeedsPasswordUpdate(true);
      } else {
        setNeedsPasswordUpdate(false);
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();

    const { name, password, confirmPassword } = kirjautumistiedot;

    if (name && password && (!needsPasswordUpdate || password === confirmPassword)) {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ kayttajatunnus: name, salasana: password })
      });

      if (response.status === 200) {
        const data = await response.json();
        const { token, id } = data;

        // Tallennetaan token localStorageen
        //localStorage.setItem('token', token);


        props.setKayttajaId(id);
        props.setToken(token);

        navigate("/");
      } else {
        alert('Käyttäjätunnus tai salasana on väärin!');
      }
    } else if (needsPasswordUpdate && password !== confirmPassword) {
      alert('Salasanat eivät täsmää!');
    }
  };

  // Ladataan token localStorage:sta (jos se on olemassa)
  //const savedToken = localStorage.getItem('token');


  //if (savedToken) {
  // Jos token löytyy, voidaan asettaa se tilaan ja mahdollisesti navigoida
  //props.setToken(savedToken);

  //navigate("/"); // Voit siirtyä suoraan etusivulle, jos käyttäjä on jo kirjautunut
  //}


  return (
    <form onSubmit={handleSubmit}>
      <TextField
        autoFocus
        required
        margin="dense"
        id="name"
        name="name"
        label="Käyttäjätunnus"
        type="text"
        fullWidth
        variant="standard"
        value={kirjautumistiedot.name}
        onChange={handleChange}
      />

      <TextField
        required
        margin="dense"
        id="password"
        name="password"
        label={needsPasswordUpdate ? "Uusi salasana" : "Salasana"}
        type="password"
        fullWidth
        variant="standard"
        value={kirjautumistiedot.password}
        onChange={handleChange}
        onFocus={handlePasswordFocus}
      />

      {needsPasswordUpdate && (
        <TextField
          required
          margin="dense"
          id="confirmPassword"
          name="confirmPassword"
          label="Anna sama salasana uudestaan"
          type="password"
          fullWidth
          variant="standard"
          value={kirjautumistiedot.confirmPassword}
          onChange={handleChange}
        />
      )}

      <Button
        type="submit"
        variant="contained"
        color="primary"
        style={{ marginTop: '16px' }}
      >
        Kirjaudu
      </Button>
    </form>
  );
};

export default Login;
